import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonService } from '../../../common/services/common.service';
import { StoreLogoViewModel } from '../../asset-library/logo-content/interfaces/store-logo.i';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { first } from 'rxjs/internal/operators/first';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { ProfileRequest, LogoContent } from '../interface/profile.i';
import { RouterConstants } from 'src/app/core/routing/constants/app-paths.constant';
import { Router } from '@angular/router';

@Component({
  selector: 'iposcen-profile-storelogo-container',
  templateUrl: './profile-storelogo-container.component.html',
  styleUrls: ['./profile-storelogo-container.component.scss']
})
export class ProfileStorelogoContainerComponent implements OnInit, OnDestroy {
 @Input() iposliteEnabled: boolean;
  tabIndex = 0;
  logoCId: string;
  profileData: string;
  defaultStoreLogos: StoreLogoViewModel;
  defaultLogoImage: any;
  bgColor: string;
  showOrHidePreview: boolean;
  showOrHidePreviewLabel: boolean;
  profileName: string;
  presentPage: string;
  currentdetailPage: string;
  profilePage: string = GlobalConstants.PROFILE;
  profileNameValue = GlobalConstants.PROFILE_NAME_LOWER_CASE;
  showDeviceWallPreview: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  isDwpRadioSelected: boolean = false;
  isDwpWallUploaded: boolean = false;
  dwpImage: any;
  dwpBgColor: string;
  fallBackImage: boolean;
  height = 0;
  width = 0; 
  defaultHW = true;
  defaultImage: string = GlobalConstants.DEFAULT_IMAGE;
  constructor(private commonService: CommonService,
    private router: Router,
    private createProfileService: CreateProfileService) { }

  ngOnInit(): void {
    this.currentdetailPage = this.router.url;
    const pageName = this.currentdetailPage.lastIndexOf('/');
    if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
      this.presentPage = GlobalConstants.ASSET_LIBRARY;
    } else if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CREATE_PROFILE ||
      this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE)) {
      this.presentPage = GlobalConstants.PROFILE;
    }
    this.defaultLogoImage = this.defaultImage;
    this.showOrHidePreview = true;
    this.bgColor = GlobalConstants.STORELOGO_BGCOLOR;
    this.commonService.getProfileName
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.profileName = data;
      });
    
    this.commonService.emitLivePreviewDataToProfileObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data[0]?.type && data[0]?.type === GlobalConstants.DEVICE_WALLPAPER_ID) {
          this.isDwpRadioSelected = (data[0]?.isDWPOptionSelected) ? true : false;
          this.isDwpWallUploaded = (!data[0]?.imageData) ? false : true;
          this.dwpImage = (!data[0]?.imageData) ? GlobalConstants.PREVIEW_IMG : data[0]?.imageData;
          this.fallBackImage =  this.dwpImage === GlobalConstants.PREVIEW_IMG;
          this.dwpBgColor = (!data[0]?.imageData) ? GlobalConstants.PREVIEW_IMG_BG: data[0]?.bgColor;
        } else {
          this.bgColor = data[0]?.bgColor;
          if (data[0].imageData) this.defaultLogoImage = data[0]?.imageData;
          if (data[0]?.clearSelectionImg) {
            this.defaultLogoImage =  this.defaultImage;
            this.bgColor = GlobalConstants.STORELOGO_BGCOLOR;
          }
        }
        //code to set image height and width for preview(as per center fit).
        if(this.dwpImage && this.dwpImage !== GlobalConstants.PREVIEW_IMG){
            this.defaultHW = false;
            var image = new Image();
            image.src = this.dwpImage;
            image.onload = ()=> { 
              this.height = Math.round(image.height/2.857);
              this.width = Math.round(image.width/2.857);
            };
        }else{
          this.defaultHW = true;
        }
      });

    this.commonService.logoContentIdObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.logoCId = res;
        this.profileData = this.createProfileService.getProfileId();
        const LogoContentInfo: LogoContent = {
          logoContentId: this.logoCId,
          showOnDevice: true
        }

        const profileRequest: ProfileRequest = {
          logoContents: [LogoContentInfo]
        }

        this.createProfileService.updateLogoContentId(this.profileData, JSON.stringify(profileRequest))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(Response => {
            //TODO
          },
            error => {
            });
      });

    this.commonService.tabIndexObser
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data === 4 || data === 5 || data === 6) {
          this.showOrHidePreview = false;
          this.showOrHidePreviewLabel = false;
          this.showDeviceWallPreview = false;
        } else if (data === 2) {
          this.showOrHidePreview = false;
          this.showOrHidePreviewLabel = false;
          this.showDeviceWallPreview = true;
        } else {
          this.showDeviceWallPreview = false;
          this.showOrHidePreview = true;
          this.showOrHidePreviewLabel = (data === 0) ? false : true;
        }
      });

  }

  setIndex(value: number) {
    this.tabIndex = value;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
